<template>
  <div>
    <b-table
      :busy="isBusy"
      show-empty
      class="tab-b"
      :items="optionsProvider"
      :fields="fieldsProvider"
      responsive="sm"
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <template slot="empty">
        <div class="alert alert-danger">
          {{ messageEstimation }}
        </div>
      </template>
      <template v-slot:cell(actions)="row">
        <b-button
          size="sm"
          @click="selectRowProvider(row.item)"
          class="mr-1 btn-rounded-orange border-none"
          >SELECCIONAR
        </b-button>
      </template>
    </b-table>
  </div>
</template>
<script>
export default {
  name: "ModalProvider",
  data() {
    return {
      fieldsProvider: [
        { key: "selected", label: " " },
        { key: "providerName", label: "Proveedor" },
        { key: "capacity", label: "Capacidad" },
        { key: "actions", label: "" },
      ],
      selectMode: "single",
    };
  },
  props: ["isBusy", "optionsProvider", "messageEstimation"],

  created() {
    //this.getListSkuProduct()
  },
  methods: {
    selectRowProvider(items) {
      this.$emit("rowProviderSelected", items);
    },
  },
};
</script>
<style scoped>
.btn-secondary:not(:disabled):not(.disabled):active {
  border-color: transparent !important;
}
.btn-secondary:focus,
.btn-secondary.focus {
  border-color: transparent !important;
}
.btn-secondary {
  border: none !important;
}

.bg-red {
  background: #ff4c4c;
}
.color-white {
  color: white;
}
.width-10 {
  width: 21px;
  height: 23px;
  text-align: center;
}
.border-gray {
  border: 1px solid gray;
}
.bg-white {
  background: white;
  border-color: gray;
}
.bg-orange {
  background: rgb(254, 123, 1) !important;
}
.text-center {
  text-align: center;
}
::v-deep .b-table thead {
  background-color: transparent !important;
  color: black !important;
  font-weight: 500 !important;
  border: none !important;
}
::v-deep .b-table thead th {
  font-weight: 700 !important;
  border: none !important;
  font-size: 11pt;
}
.btn-secondary:not(:disabled):not(.disabled):active {
  border-color: transparent !important;
}
.btn-secondary:focus,
.btn-secondary.focus {
  border-color: transparent !important;
}
</style>
